import React from 'react';
import { PromoDetailStateType } from 'entities/promo/types';
import { Drawer } from 'shared/ui/Drawer/DrawerPromo';
import {
  AddMechanicDrawer,
  AddParticipantDrawer,
  UpdatePromoCard,
  UploadBonusCard,
  UploadShopDotsCard,
} from 'entities/promo';

export const addDrawer = (id: string, state: PromoDetailStateType) => {
  const { drawerVariant } = state;

  switch (drawerVariant) {
    case 'edit':
      return (
        <Drawer title="Изменить акцию">
          <UpdatePromoCard />
        </Drawer>
      );
    case 'addMechanic':
      return (
        <Drawer title="Добавить новую механику">
          <AddMechanicDrawer promoId={id!} />
        </Drawer>
      );
    case 'addParticipant':
      return (
        <Drawer title="Добавить новую торговую точку">
          <AddParticipantDrawer promoId={id!} />
        </Drawer>
      );
    case 'uploadShopDots':
      return <UploadShopDotsCard id={id} />;
    case 'uploadBonus':
      return <UploadBonusCard id={id} />;
    default:
      return null;
  }
};
